import { Report, Lead } from '@/types';
import { AgencyReportRow } from '@/store/agencyReports';

export const demoReports: Report[] = [
  {
    id: 1,
    week: '07.07.25 - 07.13.25',
    total: 42,
    message: 18,
    message_responded: 12,
    missed_call: 10,
    answered_call: 14,
  },
  {
    id: 2,
    week: '06.30.25 - 07.06.25',
    total: 37,
    message: 15,
    message_responded: 9,
    missed_call: 8,
    answered_call: 14,
  },
  {
    id: 3,
    week: '06.23.25 - 06.29.25',
    total: 33,
    message: 12,
    message_responded: 8,
    missed_call: 7,
    answered_call: 14,
  },
  {
    id: 4,
    week: '06.16.25 - 06.22.25',
    total: 29,
    message: 10,
    message_responded: 7,
    missed_call: 6,
    answered_call: 13,
  },
  // add more objects if needed
];

const categories = ['Sales', 'Support', 'Billing', 'General'];
const reasons = ['Pricing Inquiry', 'Technical Question', 'Schedule Appointment', 'Complaint', 'Billing Issue'];
const services = ['HVAC', 'Plumbing', 'Electrical', 'Roofing'];
const cities = ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix'];

const fmt = (d: Date) => d.toISOString().slice(0,19).replace('T',' ');
const base = new Date();

export const demoAnsweredCalls: Lead[] = [
  {
    id: 5001,
    name: 'Potential Customer',
    phone: '917.555.0100',
    created_at: fmt(new Date(base.getFullYear(), base.getMonth(), base.getDate(), 12, 28, 0)),
    type: 'Answered Call',
    email: '',
    notes: [],
    shortlink: '',
    service: 'Painting',
    location: 'Boston',
    messages: [],
    reminders: [],
    lsaStatus: '',
    status: '',
    new: false,
    pause_followups: false,
    aiCall: {
      id: 9001,
      lead_id: 5001,
      audio_key: '',
      transcript: 'Deborah is inquiring about a previous estimate and needs to speak directly with the sales associate for updated information.',
      transcript_id: 0,
      summary: 'Deborah is inquiring about a previous estimate and needs to speak directly with the sales associate for updated information.',
      reason: 'Customer needs follow-up regarding previous estimate.',
      bucket: 'Lead Needs Followup',
    },
  },
  {
    id: 5002,
    name: 'Potential Customer',
    phone: '917.555.0101',
    created_at: fmt(new Date(base.getFullYear(), base.getMonth(), base.getDate(), 12, 55, 0)),
    type: 'Answered Call',
    email: '',
    notes: [],
    shortlink: '',
    service: 'Exterior Painting',
    location: 'Boston',
    messages: [],
    reminders: [],
    lsaStatus: '',
    status: '',
    new: false,
    pause_followups: false,
    aiCall: {
      id: 9002,
      lead_id: 5002,
      audio_key: '',
      transcript: 'The lead is seeking a quote for exterior painting but has not committed to booking yet.',
      transcript_id: 0,
      summary: 'The lead is seeking a quote for exterior painting but has not committed to booking yet.',
      reason: 'Customer requested quote but has not booked yet.',
      bucket: 'Lead Needs Followup',
    },
  },
  {
    id: 5003,
    name: 'Jakob',
    phone: '917.555.0102',
    created_at: fmt(new Date(base.getFullYear(), base.getMonth(), base.getDate(), 13, 15, 0)),
    type: 'Answered Call',
    email: '',
    notes: [],
    shortlink: '',
    service: 'Plumbing',
    location: 'Boston',
    messages: [],
    reminders: [],
    lsaStatus: '',
    status: '',
    new: false,
    pause_followups: false,
    aiCall: {
      id: 9003,
      lead_id: 5003,
      audio_key: '',
      transcript: 'Jakob says the plumbing company does not provide the service he needs so he\'s going to a different company.',
      transcript_id: 0,
      summary: 'Jakob says the plumbing company does not provide the service he needs so he\'s going to a different company.',
      reason: 'Jakob says the plumbing company does not provide the service he needs so he\'s going to a different company.',
      bucket: 'Lead Lost',
    },
  },
  {
    id: 5004,
    name: 'Laura',
    phone: '917.555.0103',
    created_at: fmt(new Date(base.getFullYear(), base.getMonth(), base.getDate(), 14, 5, 0)),
    type: 'Answered Call',
    email: '',
    notes: [],
    shortlink: '',
    service: 'HVAC',
    location: 'Boston',
    messages: [],
    reminders: [],
    lsaStatus: '',
    status: '',
    new: false,
    pause_followups: false,
    aiCall: {
      id: 9004,
      lead_id: 5004,
      audio_key: '',
      transcript: '',
      transcript_id: 0,
      summary: '',
      reason: 'Laura booked with the HVAC company and they\'re coming to her house at 4330 Nautilus Drive at 11 am on Tuesday.',
      bucket: 'Lead Won',
    },
  },
];

export const demoAgencyReports: AgencyReportRow[] = [
  {
    id: 101,
    user_id: 301,
    name: 'Demo User 1',
    email: 'demo1@example.com',
    company: 'Demo Co A',
    total: 22,
    message: 8,
    message_responded: 6,
    missed_call: 5,
    answered_call: 9,
  },
  {
    id: 102,
    user_id: 302,
    name: 'Demo User 2',
    email: 'demo2@example.com',
    company: 'Demo Co B',
    total: 15,
    message: 6,
    message_responded: 4,
    missed_call: 3,
    answered_call: 6,
  },
  {
    id: 103,
    user_id: 303,
    name: 'Demo User 3',
    email: 'demo3@example.com',
    company: 'Demo Co C',
    total: 12,
    message: 4,
    message_responded: 3,
    missed_call: 2,
    answered_call: 6,
  },
];

export const demoAgencyAggregated = {
  total: demoAgencyReports.reduce((s, r) => s + r.total, 0),
  message: demoAgencyReports.reduce((s, r) => s + r.message, 0),
  message_responded: demoAgencyReports.reduce((s, r) => s + r.message_responded, 0),
  missed_call: demoAgencyReports.reduce((s, r) => s + r.missed_call, 0),
  answered_call: demoAgencyReports.reduce((s, r) => s + r.answered_call, 0),
}; 